import React, {Component} from "react";
import {Card, Typography, Icon, Button} from 'antd';
import {appStore} from "../stores/AppStore";
import '../aboutus.css';

const {Title, Text} = Typography;

const cardStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

const aboutStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
};

const noticeStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginTop: '5%',
    justifyContent: 'left',
    alignItems: 'left'
};

const purposeStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginTop: '5%',
    justifyContent: 'left',
    alignItems: 'left'
};


class Profiles extends Component {
    render() {
        return (
            <div>
                <Card style={cardStyle} title={<Title level={2}>Profiles</Title>} actions={[this.renderLogoutButton()]}>
                    <div style={aboutStyle}>
                        <Text>Pubkit - KLI</Text>
                        <Text>Version 0.1</Text>
                        <Text>Aug-2019</Text>
                        <Text><Icon type="copyright"/>&nbsp;Newgen KnowlegeWorks</Text>
                    </div>
                    <div style={purposeStyle}>
                        <Text>The primary objectives of this micro-site are:</Text>
                        <Text><Icon type="caret-right" theme="filled"/>&nbsp;to facilitate our stakeholders, to manage
                            LooseLeaves</Text>
                        <Text><Icon type="caret-right" theme="filled"/>&nbsp;to allow them, to monitor the status of
                            LooseLeaves</Text>
                    </div>
                    <div style={noticeStyle}>
                        <Text>This micro-site is exclusively developed for KLI.</Text>
                        <Text>We are focusing on managing the LooseLeaves as of now.</Text>
                        <Text>Some of the listed features are being developed and will be available shortly.</Text>
                        <Text>Looking forward to your support and encouragement.</Text>
                        <Text>&nbsp;</Text>
                        <Text>Thank you!!!</Text>
                    </div>
                </Card>
            </div>
        )
    }

    renderLogoutButton() {
        if (!appStore.isLoggedIn()) return null;

        return (
            <Button onClick={appStore.logout}>Logout</Button>
        )
    }
}

export default Profiles;
